import React, { useContext, useEffect, useState } from 'react'
import { startOfWeek, addWeeks, getISOWeek, getISOWeeksInYear, getISOWeekYear } from 'date-fns'
import dateConver from '../Tools/DateConverter'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
import { ContextGloball } from '../Context/ContextGlobal';
import VerificarPermisos from '../Tools/VerificarPermisos';
import ConsultasReporte from '../Sql/ConsultasReporte';
import ConsultasComunes from '../Sql/ConsultasComunes';
import axios from 'axios';
import { subDays,isValid,parseISO} from 'date-fns';

const server = process.env.REACT_APP_SERVER;

function RequerimientoSemanal() {
    const { loading, setLoading } = useContext(ContextGloball);
    const [reg, setReg] = useState('');
    const [numSemana, setNumSemana] = useState(0);
    const [anio, setAnio] = useState(0);
    const [actualizar, setActualizar] = useState(false);
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(0);
    const [reqSemanal, setReqSemanal] = useState([]);
    const [listaDias, setListaDias] = useState([]);
    const [selectItem, setSelectItem] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [tipoModal, setTipoModal] = useState('');
    const [itemSucursal, setItemSucursal] = useState(null);
    const [productosEdit, setProductosEdit] = useState(null);
    const [proyeccionHistorica, setProyeccionHistorica] = useState([]);
    const [productosOriginales, setProductosOriginales] = useState([]);
    const [fechaPasadaDeHaceSieteDias, setFechaPasada] = useState('');
    const [promedioTresSemanas, setPromedioTresSemanas] = useState([]);
    const [promedio, setFechaPasadaHaceCuatroSemanas] = useState('');
    const [diasTolerancia,setDiasTolerancia] = useState(0);
    

    const puedeEditar = (fechaProducto) => {
        
        const hoyStr = new Date().toISOString().split('T')[0];
        const hoy = new Date(hoyStr);

       
        const fechaAux = new Date(hoy);
        fechaAux.setDate(fechaAux.getDate() + diasTolerancia);

        
        const fechaProd = new Date(fechaProducto.split('T')[0]);

        
        return fechaProd > fechaAux;
    };

    //const puedeGuardar = productosEdit?.some(item => puedeEditar(item.FECHA));

    const puedeGuardar = (VerificarPermisos.validarPermiso('52') == true) || (itemSucursal?.VALIDADO_POR == null);
   
    const copiarValoresHistoricos = () => {
        if (proyeccionHistorica.length === 0) return;

        const nuevosProductos = productosEdit.map(prodActual => {
            const historico = proyeccionHistorica.find(h => h.ID_PRODUCTO === prodActual.ID_PRODUCTO);
            return historico ? { ...prodActual, CANTIDAD: historico.CANTIDAD } : prodActual;
        });

        // Esto actualiza los inputs en el DOM automáticamente
        setProductosEdit(nuevosProductos); 
    };

    async function obtenerProyeccionAnterior(fechaRecibida, idSucursal) {
        if (!fechaRecibida) return;

        let fechaBase;

        // Si la fecha es un string, intentamos parsearla
        if (typeof fechaRecibida === 'string') {
            // Caso A: Formato ISO o YYYY-MM-DD (ej: 2024-08-15)
            if (fechaRecibida.includes('-') && fechaRecibida.split('-')[0].length === 4) {
                fechaBase = parseISO(fechaRecibida);
            } 
            // Caso B: Formato DD/MM/YYYY (ej: 15/08/2024)
            else {
                const partes = fechaRecibida.includes('/') ? fechaRecibida.split('/') : fechaRecibida.split('-');
                const d = parseInt(partes[0], 10);
                const m = parseInt(partes[1], 10) - 1;
                const a = parseInt(partes[2], 10);
                fechaBase = new Date(a, m, d);
            }
        } else {
            // Caso C: Ya es un objeto Date
            fechaBase = new Date(fechaRecibida);
        }

        if (!isValid(fechaBase)) {
            console.error("Fecha inválida recibida:", fechaRecibida);
            return;
        }

        // Calcular fecha de hace 7 días
        const fechaPasada = subDays(fechaBase, 7);
        
        setFechaPasada(fechaPasada);
        // Obtener Semana y Año ISO correctos
        const semanaPasada = getISOWeek(fechaPasada);
        const anioPasado = getISOWeekYear(fechaPasada);

        console.log(`Consultando histórico - Semana: ${semanaPasada}, Año: ${anioPasado}`);

        const consulta = {
            fechaIni: dateConver.formatoFechaNumeric(fechaPasada),
            fechaFin: dateConver.formatoFechaNumeric(fechaPasada),
            sucursal: idSucursal,
            regional: reg,
            semana: semanaPasada,
            anio: anioPasado
        };

        try {
            const res = await fetch(`${server}/reporte/getReqSemanal`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(consulta)
            });
            const data = await res.json();
            if (data.ok && data.ok.length > 0) {
                // Buscamos los detalles de la sucursal que estamos editando
                const sucursalData = data.ok.find(s => s.ID_SUCURSAL == idSucursal);
                setProyeccionHistorica(sucursalData ? sucursalData.DETALLE : []);
            } else {
                setProyeccionHistorica([]);
            }
            if(data.dias_tolerancia){
                setDiasTolerancia(data.dias_tolerancia);
            }
        } catch (error) {
            console.error("Error histórico:", error);
        }
    }


    async function obtenerPromedioVentasCalculado(fechaRecibida, idSucursal) {
        if (!fechaRecibida || !idSucursal) return;

        // 1. Normalizar fecha de referencia (hoy)
        let fechaFin = (typeof fechaRecibida === 'string') 
            ? (fechaRecibida.includes('-') && fechaRecibida.split('-')[0].length === 4 
                ? parseISO(fechaRecibida) 
                : new Date(fechaRecibida.split('/')[2], fechaRecibida.split('/')[1]-1, fechaRecibida.split('/')[0]))
            : new Date(fechaRecibida);

        // 2. Definir rango: Fin es hoy, Inicio es hace 1 año (para festivos en el SQL)
        const fechaIniFestivos = subDays(fechaFin, 365);
        setFechaPasadaHaceCuatroSemanas(fechaFin); // Para el texto de la UI

        const consulta = {
            fechaIni: dateConver.formatoFechaNumeric(fechaIniFestivos),
            fechaFin: dateConver.formatoFechaNumeric(fechaFin),
            idSucursal: idSucursal,
            regional: reg, // variable de tu scope
            diasProm: 3    // Queremos promedio de 3 semanas
        };

        try {
            const res = await fetch(`${server}/reporte/getPromedioVentasCalculado`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(consulta)
            });
            const data = await res.json();
            
            if (data.ok) {
                setPromedioTresSemanas(data.ok);
            } else {
                setPromedioTresSemanas([]);
            }
        } catch (error) {
            console.error("Error al obtener promedio:", error);
        }
    }


    function getNumSemanaHoy() {
        var fechaHoy = new Date()
        var oneJan = new Date(fechaHoy.getFullYear(), 0, 1);
        var numberOfDays = Math.floor((fechaHoy - oneJan) / (24 * 60 * 60 * 1000));
        var result = Math.ceil((fechaHoy.getDay() + 1 + numberOfDays) / 7);
        return getISOWeek(fechaHoy)
    }


    async function obtenerDatos(nSemana, nAnio) {
        setLoading(true);
        var info = JSON.parse(localStorage.getItem('info'));
        var firstDayOfWeek = startOfWeek(new Date(nAnio, 0, 1)); // Inicio del año
        var fechaAconsultar = addWeeks(firstDayOfWeek, nSemana - 1);
        var fechafin = new Date(fechaAconsultar)
        fechafin.setDate(fechaAconsultar.getDate() + 7);
        fechaAconsultar.setDate(fechaAconsultar.getDate() + 1);
        var semanaUltimaAno = getISOWeeksInYear(new Date(nAnio, 0, 1));
        var nanioo = 0, numsemana = 0;
        if (nSemana != 0) {
            if (semanaUltimaAno == nSemana - 1) {
                nanioo = nAnio + 1;
                numsemana = 1
                setAnio(nAnio + 1);
                setNumSemana(1);
            } else {
                nanioo = nAnio;
                numsemana = nSemana;
            }
        } else {
            setAnio(nAnio - 1);
            setNumSemana(semanaUltimaAno)
            nanioo = nAnio - 1;
            numsemana = semanaUltimaAno;
        }

        const consulta = {
            fechaIni: dateConver.formatoFechaNumeric(fechaAconsultar),
            fechaFin: dateConver.formatoFechaNumeric(fechafin),
            sucursal: idSucursal,
            regional: reg == '' ? info.ID_REGIONAL_ACTUAL : reg,
            semana: numsemana,//semanaUltimaAno==nSemana-1?1:nSemana,
            anio: nanioo//==nSemana-1?nAnio+1:nAnio
        }
        try {
            await fetch(`${server}/reporte/getReqSemanal`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(consulta)
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        if (data.ok.length == 0) {
                            MsgUtils.msgAdvertencia("no hay dat")
                        } else {
                            //var diaL = [...new Set(data.ok[0].DETALLE.map(item => item.DIA))];
                            let diasObtenidos = getDayNumbersOfWeek(nAnio, nSemana - 1);
                            setListaDias(diasObtenidos)
                            //setListaDias(diaL);
                            console.log(data.ok)
                            setReqSemanal(data.ok);

                        }
                    } else {
                        MsgUtils.msgError(data.error)
                    }
                    setLoading(false);
                })
                .catch(err => console.log(err));
        } catch (error) {
            console.log(error.message)
        }
    }




    function getSucursalesR(regional) {
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    setActualizar(!actualizar)
                    MsgUtils.msgError(data.error);
                } else {
                    var filtro = data.ok.sort((a, b) => a.ID_SUCURSAL - b.ID_SUCURSAL)
                    console.log(filtro);
                    setSucursales(filtro);
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }

    function getDetalle(lista, d, otroItem) {
        var filtradoL = lista.filter(item => item.DIA == d);
        if (filtradoL.length != 0) {
            return (
                <div className='container-fluid bg-dark border-light m-2 m-md-3 p-4 pe-5 p-md-4'>
                    <div className='row row-cols-auto justify-content-center g-1 m-3 text-center'>
                         <div className=''>
                            <button className='btn btn-secondary btn-sm'
                                title={`Detalles proyección del ${dateConver.formatoFechaCorto(filtradoL[0].FECHA)}`}
                                onClick={() => {
                                    setItemSucursal(otroItem);
                                    setProductosEdit(filtradoL); 
                                    setProductosOriginales(JSON.parse(JSON.stringify(filtradoL))); // 👈 copia profunda
                                    setTipoModal('E'); 
                                    setModalShow(true); 
                                    obtenerProyeccionAnterior(filtradoL[0].FECHA, filtradoL[0].ID_SUCURSAL); 
                                    obtenerPromedioVentasCalculado(filtradoL[0].FECHA, filtradoL[0].ID_SUCURSAL)
                                }}>
                                Detalles </button>
                        </div>
                       <div className='col text-center colorLetra bg-light fw-bold'>
                        <div 
                            className="col text-center colorLetra bg-light fw-bold" 
                            style={{ whiteSpace: 'pre-line', lineHeight: '1.2' }}
                        >
                            {/* Partimos por el "-", invertimos el orden y unimos con salto de línea */}
                            {dateConver.formatoFechaCorto(filtradoL[0].FECHA).split('-').reverse().join('\n')}
                        </div>
                        </div>
                    </div>
                    <div style={{ marginRight: '-5px' ,marginLeft: '-10px' }}>
                        {filtradoL.map((item, index) => {
                            return (
                                <div className='w-100 text-light borderC' style={{ fontSize: "13px" }} key={index}>{item.ABREVIACION}: <span className='text-light' style={{ fontSize: "10px" }}>{item.CANTIDAD + ' ' + item.UNIDAD}</span></div>
                            )
                        })}
                    </div>
                </div>
            )
        }
    }

    function getTotalSemanal(lista) {
        var productos = [...new Set(lista.map(item => item.ID_PRODUCTO))]
        var productosFinal = [];
        for (var pro of productos) {
            var listaProducto = lista.filter(item => item.ID_PRODUCTO == pro);
            var total = listaProducto.map(item => item.CANTIDAD).reduce((a, b) => a + b, 0);
            productosFinal.push({ ...listaProducto[0], 'CANTIDAD': total });
        }
        return (
            <div className='container-fluid bg-dark border-light m-0 p-1 border rounded m-5 m-md-4 p-3'>
                <div className='text-center colorLetra fondoNaranja fw-bold'>
                    TOTAL
                </div>
                <>
                    {productosFinal.map((item, index) => {
                        return (
                            <div className='w-100 text-light borderC' style={{ fontSize: "13px" }} key={index}>{item.ABREVIACION}: <span className='text-light' style={{ fontSize: "10px" }}>{item.CANTIDAD + ' ' + item.UNIDAD}</span></div>
                        )
                    })}
                </>
            </div>
        )
    }
    function validarRequerimiento() {
        var datos = JSON.parse(localStorage.getItem('info'))
        fetch(`${server}/reporte/validarRequerimiento`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                numSemana, anio, 'idSucursal': selectItem.ID_SUCURSAL, 'regional': '' + reg, 'idEmpleado': datos.ID_EMPLEADO
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setModalShow(false);
                    MsgUtils.msgCorrecto(data.ok);
                    obtenerDatos(numSemana, anio);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function desvalidarRequerimiento(dato) {
        fetch(`${server}/reporte/delValidacionRequ`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                numSemana, anio, 'idSucursal': dato.ID_SUCURSAL, 'regional': '' + reg
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    obtenerDatos(numSemana, anio);
                } else {
                    MsgUtils.msgError(data.error)
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    function obtenerCabecera(dato) {
        return (
            <div className='container-fluid'>
                <div className='row row-cols-2 g-1'>
                    <div className='col col-8 col-sm-8 col-md-10'>
                        <div className='text-center colorLetra bg-light fw-bold'>
                            {dato.SUCURSAL}
                        </div>
                        {dato.VALIDADO_POR !== null && <div className='text-center w-100 text-light' style={{ fontSize: '14px' }}>
                            Validado por: {dato.NOMBREX}
                        </div>}
                    </div>
                    <div className='col col-4 col-sm-4 col-md-2 text-end'>
                        {dato.VALIDADO_POR !== null && VerificarPermisos.validarPermiso('52') == true && <button className='btn btn-danger '
                            onClick={() => desvalidarRequerimiento(dato)}>
                            Desvalidar</button>}
                        {dato.VALIDADO_POR == null && <button className='btn btnSinVal fw-bold'
                            disabled={VerificarPermisos.validarPermiso('40') == false ? true : false}
                            onClick={() => { setSelectItem(dato); setModalShow(true); setTipoModal('V') }}>
                            Sin validar
                        </button>}
                    </div>
                </div>
            </div>
        )
    }
    function comprobarFiltro(datos) {
        if (idSucursal == 0) {
            return true
        } else {
            return idSucursal == datos.ID_SUCURSAL
        }
    }
    function obtenerTotalRequeriemiento(dia) {
        var listaProductos = [];
        for (var req of reqSemanal) {
            listaProductos.push(...req.DETALLE.filter((item) => item.DIA == dia))
        }
        var productosFinal = [];
        var productos = [...new Set(listaProductos.map(item => item.ID_PRODUCTO))];
        for (var pro of productos) {
            var listaProducto = listaProductos.filter(item => item.ID_PRODUCTO == pro);
            var total = listaProducto.map(item => item.CANTIDAD).reduce((a, b) => a + b, 0);
            productosFinal.push({ ...listaProducto[0], 'CANTIDAD': total });
        }
        if (productosFinal.length != 0) {
            return (
                <div className='container-fluid bg-dark border-light m-0 p-1 border rounded'>
                    <div className='text-center colorLetra fondoNaranja fw-bold '>
                        {dateConver.formatoFechaCorto(productosFinal[0].FECHA)}
                    </div>
                    <>
                        {productosFinal.map((item, index) => {
                            return (
                                <div className='w-100 text-light borderC' style={{ fontSize: "13px" }} key={index}>{item.ABREVIACION}: <span className='text-light' style={{ fontSize: "10px" }}>{item.CANTIDAD + ' ' + item.UNIDAD}</span></div>
                            )
                        })}
                    </>
                </div>
            )
        }
    }
    function obtenerTotalFinal() {
        var listaProductos = []
        for (var req of reqSemanal) {
            listaProductos.push(...req.DETALLE);
        }
        var productos = [...new Set(listaProductos.map(item => item.ID_PRODUCTO))];
        var productosFinal = []
        for (var pro of productos) {
            var listaProducto = listaProductos.filter(item => item.ID_PRODUCTO == pro);
            var total = listaProducto.map(item => item.CANTIDAD).reduce((a, b) => a + b, 0);
            productosFinal.push({ ...listaProducto[0], 'CANTIDAD': total });
        }
        if (productosFinal.length != 0) {
            return (
                <div className='container-fluid bg-dark border-light m-0 p-1 border rounded'>
                    <div className='text-center colorLetra bg-secondary fw-bold text-light '>
                        SUMATORIA
                    </div>
                    <>
                        {productosFinal.map((item, index) => {
                            return (
                                <div className='w-100 text-light borderC' style={{ fontSize: "13px" }} key={index}>{item.ABREVIACION}: <span className='text-light' style={{ fontSize: "10px" }}>{item.CANTIDAD + ' ' + item.UNIDAD}</span></div>
                            )
                        })}
                    </>
                </div>
            )
        }
    }

    const editarProducto = async () => {
        var listaAguardar = []
        let ediciones = []
        var info = JSON.parse(localStorage.getItem('info'));

        let sucursal = sucursales.filter(sucursal => sucursal.ID_SUCURSAL == productosEdit[0].ID_SUCURSAL);

        let infoColaborador = await ConsultasComunes.getInfoColaborador({ 'regional': reg, 'idEmpleado': info.ID_EMPLEADO })

        //let infoSucursal = await ConsultasComunes.getNombreSucursalDadoID({ 'id_sucursal': productosEdit[0].ID_SUCURSAL, 'regional': reg});

        for (var dato of productosEdit) {

            const original = productosOriginales.find(p => 
                p.ID_PRODUCTO === dato.ID_PRODUCTO
            );

            if (!original) continue;

            if (parseInt(original.CANTIDAD) !== parseInt(dato.CANTIDAD)) {

                listaAguardar.push({ 
                    ...dato, 
                    CANTIDAD: parseInt(dato.CANTIDAD), 
                    ID_EMPLEADO: info.ID_EMPLEADO 
                });

                ediciones.push({
                    PRODUCTO: dato.ABREVIACION,
                    CANTIDAD_MODIFICADA: parseInt(dato.CANTIDAD),
                    CANTIDAD_ORIGINAL: parseInt(original.CANTIDAD)
                });
            }
        }
        try {
            var result = await ConsultasReporte.editarProyeccionSemanal({ 'PRODUCTOS': listaAguardar, 'regional': info.ID_REGIONAL_ACTUAL })
            if (result.ok) {
                setProductosEdit(null);
                setTipoModal('');
                setModalShow(false);
                setActualizar(!actualizar);
                if (ediciones.length > 0) {
                    let mensaje = "Se registró una modificacion en proyecciones: \n\n"
                        + "Modificado por: " + infoColaborador.ok[0].NOMBRES + " " + infoColaborador.ok[0].APELLIDO_PATERNO + " " + infoColaborador.ok[0].APELLIDO_MATERNO + "\n"
                        + "Sucursal: " + sucursal[0].SUCURSAL + "\n"
                        + "Fecha de proyección: " + productosEdit[0].DIA + "/" + productosEdit[0].MES + "/" + productosEdit[0].ANIO + "\n\n";

                    for (let edicion of ediciones) {
                        mensaje += "Producto: " + edicion.PRODUCTO + "\n"
                            + "   Cantidad Original: " + edicion.CANTIDAD_ORIGINAL + "\n"
                            + "   Cantidad Actualizada: " + edicion.CANTIDAD_MODIFICADA + "\n\n";
                    }

                    const publicacion = await axios.post('https://api.telegram.org/bot2089085276:AAEjGuDcNhpfuR299JUJxmnPCaazsEZopgc/sendMessage',
                        {
                            //-1002160171254
                            //8116303051
                            chat_id: -1002160171254,
                            parse_mode: 'html',
                            text: mensaje
                        });
                }
                MsgUtils.msgCorrecto(result.ok);
            } else {
                MsgUtils.msgError(result.error);
            }
        } catch (error) {
            MsgUtils.msgError(error)
        }
        setProductosOriginales([]);

    }

    async function completarProyecciones() {
        const inicioDia = performance.now();
        setLoading(true);
        let id_productos;

        const sucursalesAusentes = sucursales.filter(sucursal =>
            !reqSemanal.some(s => s.ID_SUCURSAL === sucursal.ID_SUCURSAL)
        );

        let sucursalesPresentes = reqSemanal;

        for (const sucursalPresente of sucursalesPresentes) {

            id_productos = [-3, 121, 122, 187, 158, 159, 160, 1450];

            if (sucursalPresente.ID_SUCURSAL == 11 || sucursalPresente.ID_SUCURSAL == 39 || sucursalPresente.ID_SUCURSAL == 29) {
                id_productos = [-3, 121, 122, 187, 1040, 1041, 1042, 1450];
            }

            if (sucursalPresente.DETALLE.length == 56) {

                console.log("Sucursal completa", sucursalPresente.SUCURSAL)

            } else {

                let productosAgregar = [];

                for (const diaSeleccionado of listaDias) {

                    const diasFiltrados = sucursalPresente.DETALLE.filter(item => item.DIA == diaSeleccionado);

                    if (diasFiltrados.length != 8) {

                        if (diasFiltrados.length != 0) {
                            //console.log("SUCURSAL: " + sucursalPresente.ID_SUCURSAL)

                            //console.log("Dias filtrados: ")
                            //console.log(diasFiltrados)

                            //console.log("primer producto: ")
                            //console.log(diasFiltrados[0])

                            let idProductosAgregar = obtenerProductosProblematicos(id_productos, diasFiltrados);

                            //console.log("Productos Problematicos");
                            //console.log(idProductosAgregar);

                            for (const idProducto of idProductosAgregar) {
                                let producto = {
                                    TIPO: 'S',
                                    ID_SUCURSAL: sucursalPresente.ID_SUCURSAL,
                                    ANIO: anio,
                                    MES: diasFiltrados[0].MES,
                                    DIA: diasFiltrados[0].DIA,
                                    ID_PRODUCTO: idProducto,
                                    CANTIDAD: 0,
                                    FECHA: `${diasFiltrados[0].DIA}/${diasFiltrados[0].MES}/${anio}`,
                                    EMPLEADO: 474,
                                };
                                productosAgregar.push(producto);
                            }

                        } else {

                            let mesGenerado = getMonthByWeekDay(anio, numSemana, diaSeleccionado);

                            for (const idProducto of id_productos) {

                                let producto = {
                                    TIPO: 'S',
                                    ID_SUCURSAL: sucursalPresente.ID_SUCURSAL,
                                    ANIO: anio,
                                    MES: mesGenerado,
                                    DIA: diaSeleccionado,
                                    ID_PRODUCTO: idProducto,
                                    CANTIDAD: 0,
                                    FECHA: `${diaSeleccionado}/${mesGenerado}/${anio}`,
                                    EMPLEADO: 474,
                                };
                                productosAgregar.push(producto);
                            }
                        }
                    }
                }

                if (productosAgregar.length > 0) {
                    var response1 = await fetch(`${server}/reporte/addProyeccionDetalle`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },

                        body: JSON.stringify({
                            'regional': reg,
                            'PRODUCTOS': productosAgregar,
                            'DIAS': []
                        })
                    });

                    if (response1.ok) {
                        console.log(response1.ok)
                    } else {
                        setLoading(false);
                        MsgUtils.msgError("No se pudo guardar los detalles de la proyeccion.");
                    }

                } else {
                    console.log(sucursalPresente.SUCURSAL)
                    console.log("Nada que agregar")
                }
            }
        }

        for (let index = 0; index < sucursalesAusentes.length; index++) {

            if (sucursalesAusentes[index].ID_SUCURSAL == 9) {
            } else {
                var response = await fetch(`${server}/reporte/addProyeccion`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'regional': reg,
                        'id_empleado': 474,
                        'anio': anio,
                        'semana': numSemana,
                        'id_sucursal': sucursalesAusentes[index].ID_SUCURSAL,
                    })
                });

                if (response.ok) {

                    id_productos = [-3, 121, 122, 187, 158, 159, 160, 1450];

                    if (sucursalesAusentes[index].ID_SUCURSAL == 11 || sucursalesAusentes[index].ID_SUCURSAL == 39 || sucursalesAusentes[index].ID_SUCURSAL == 29) {
                        id_productos = [-3, 121, 122, 187, 1040, 1041, 1042, 1450];
                    }

                    let productos = [];
                    let dias = [];

                    for (let x = 0; x < listaDias.length; x++) {
                        let dia = {
                            DIA: listaDias[x],
                            MES: getMonthByWeekDay(anio, numSemana, listaDias[x]),
                        };
                        dias.push(dia);
                    }

                    for (let y = 0; y < id_productos.length; y++) {

                        let producto = {
                            TIPO: 'S',
                            ID_SUCURSAL: sucursalesAusentes[index].ID_SUCURSAL,
                            ANIO: anio,
                            ID_PRODUCTO: id_productos[y],
                            CANTIDAD: 0,
                            EMPLEADO: 474,
                        };

                        productos.push(producto);
                    }

                    var response1 = await fetch(`${server}/reporte/addProyeccionDetalle`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },

                        body: JSON.stringify({
                            'regional': reg,
                            'PRODUCTOS': productos,
                            'DIAS': dias
                        })
                    });

                    if (response1.ok) {
                        console.log(response1.ok)
                    } else {
                        setLoading(false);
                        MsgUtils.msgError("No se pudo guardar los detalles de la proyeccion.");
                    }

                } else {
                    setLoading(false);
                    MsgUtils.msgError("No se pudo guardar los detalles de la proyeccion.");
                }
            }
        }

        const finDia = performance.now();
        const tiempoDia = (finDia - inicioDia) / 1000;
        console.log(`tomo ${tiempoDia.toFixed(3)} segundos`);

        setLoading(false);
        setActualizar(!actualizar);
    }

    function obtenerProductosProblematicos(id_productos, arregloObjetos) {
        return id_productos.filter(id => {
            const item = arregloObjetos.find(obj => obj.ID_PRODUCTO === id);
            return !item || item.TIPO !== 'S';
        });
    }

    function getDayNumbersOfWeek(year, weekNumber) {
        const firstDayOfYear = new Date(year, 0, 1);
        const firstDayOfWeek = firstDayOfYear.getDay();

        const daysToFirstMonday = firstDayOfWeek <= 1 ?
            1 - firstDayOfWeek :
            8 - firstDayOfWeek;

        const weekMonday = new Date(firstDayOfYear);
        weekMonday.setDate(firstDayOfYear.getDate() + daysToFirstMonday + (weekNumber - 1) * 7);

        const dayNumbers = [];
        for (let i = 0; i < 7; i++) {
            const currentDate = new Date(weekMonday);
            currentDate.setDate(weekMonday.getDate() + i);
            dayNumbers.push(currentDate.getDate());
        }

        return dayNumbers;

    }

    const getMonthByWeekDay = (year, week, day) => {
        const baseDate = startOfWeek(new Date(year, 0, 1), { weekStartsOn: 1 }); // Inicio del año

        const weekStart = new Date(baseDate);
        weekStart.setDate(baseDate.getDate() + ((week - 1) * 7));

        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        console.log('weekStart: ' + weekStart + ', weekEnd: ' + weekEnd);

        const targetDate = new Date(weekStart.getFullYear(), weekStart.getMonth(), day);

        if (targetDate < weekStart) {
            targetDate.setMonth(weekStart.getMonth() + 1);
        }

        if (targetDate < weekStart || targetDate > weekEnd) {
            throw new Error(`El día ${day} no pertenece a la semana ${week} de ${year}`);
        }

        return targetDate.getMonth() + 1;
    };

    useEffect(() => {
        if (numSemana === 0 && anio === 0) {
            var info = JSON.parse(localStorage.getItem('info'));
            setReg(info.ID_REGIONAL_ACTUAL);
            var fechaHoy = new Date()
            var result = getNumSemanaHoy();
            setAnio(getISOWeekYear(fechaHoy));
            setNumSemana(result);
            getSucursalesR(info.ID_REGIONAL_ACTUAL);
            obtenerDatos(result, getISOWeekYear(fechaHoy))
        } else {
            obtenerDatos(numSemana, anio)
        }
    }, [actualizar])
    return (
    <>
        {/* SECCIÓN DE FILTROS */}
        <div className='container-fluid bg-dark bg-gradient py-1'>
            <div className='row g-2'>
                <div className='col' style={{ maxWidth: '115px' }}>
                    <div className='btn-group'>
                        <button className='btn btn-light' onClick={() => { setNumSemana(numSemana - 1); obtenerDatos(numSemana - 1, anio) }}>
                            <i className="fa-solid fa-chevron-left"></i>
                        </button>
                        <div className='bg-light fw-bold text-dark my-auto bg-gradient px-1' style={{ fontSize: '25px' }}>{numSemana}</div>
                        <button className='btn btn-light' onClick={() => { setNumSemana(numSemana + 1); obtenerDatos(numSemana + 1, anio) }}>
                            <i className="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                    <div className='text-light text-center w-100' style={{ fontSize: '10px' }}># Semana</div>
                </div>

                <div className='col' style={{ maxWidth: '145px' }}>
                    <div className='btn-group'>
                        <button className='btn btn-light' onClick={() => { setAnio(anio - 1); obtenerDatos(numSemana, anio - 1) }}>
                            <i className="fa-solid fa-chevron-left"></i>
                        </button>
                        <div className='bg-light fw-bold text-dark my-auto bg-gradient px-1' style={{ fontSize: '25px' }}>{anio}</div>
                        <button className='btn btn-light' onClick={() => { setAnio(anio + 1); obtenerDatos(numSemana, anio + 1) }}>
                            <i className="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                    <div className='text-light text-center w-100' style={{ fontSize: '10px' }}>Año</div>
                </div>

                <div className='col' style={{ maxWidth: '120px' }}>
                    <select className="form-select" aria-label="Default select example" value={idSucursal} onChange={(e) => setIdSucursal(e.target.value)}>
                        <option value={0}>TODOS</option>
                        {sucursales.map((item, index) => (
                            <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                        ))}
                    </select>
                    <div className='text-light text-center w-100' style={{ fontSize: '10px' }}>Sucursal</div>
                </div>

                <div className='col' style={{ maxWidth: '120px' }}>
                    <button className='btn btn-success bg-gradient w-100' onClick={() => setActualizar(!actualizar)}>
                        <i className="fa-solid fa-rotate"></i> Cargar
                    </button>
                </div>

                {VerificarPermisos.validarPermiso('79') && (
                    <div className='col' style={{ maxWidth: '200px' }}>
                        <button className='btn btn-info bg-gradient w-100' onClick={() => completarProyecciones()}>
                            <i className="fa-solid fa-wand-magic"></i> Completar proyecciones
                        </button>
                    </div>
                )}
            </div>
        </div>

        {/* TABLAS POR SUCURSAL */}
        {reqSemanal.map((item, index) => {
            if (comprobarFiltro(item)) {
                return (
                    <div className='bg-dark bg-gradient' key={index}>
                        {obtenerCabecera(item)}
                        <div className='table-responsive'>
                            <table className="table table-dark">
                                <thead>
                                    <tr className='text-center'>
                                        <th>Lunes</th>
                                        <th>Martes</th>
                                        <th>Miercoles</th>
                                        <th>Jueves</th>
                                        <th>Viernes</th>
                                        <th>Sabado</th>
                                        <th>Domingo</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        {listaDias.map((dia, i) => (
                                            <td className='bg-gradient' key={i}>
                                                {getDetalle(item.DETALLE, dia, item)}
                                            </td>
                                        ))}
                                        <td className='bg-gradient'>
                                            {getTotalSemanal(item.DETALLE)}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            }
            return null;
        })}

        {/* TOTAL REQUERIMIENTOS (CUANDO ES TODOS) */}
        {idSucursal == 0 && reqSemanal.length !== 0 && (
            <div className='bg-dark bg-gradient'>
                <div className='container-fluid'>
                    <div className='row row-cols-2 g-1'>
                        <div className='col col-8 col-sm-8 col-md-10'>
                            <div className='text-center colorLetra bg-light fw-bold'>
                                Total Requerimientos
                            </div>
                        </div>
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className="table table-dark" >
                        <thead>
                            <tr className='text-center'>
                                <th style={{ width: '200px' }} >Lunes</th>
                                <th>Martes</th>
                                <th>Miercoles</th>
                                <th>Jueves</th>
                                <th>Viernes</th>
                                <th>Sabado</th>
                                <th>Domingo</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {listaDias.map((dia, i) => (
                                    <td className='bg-gradient' key={i}>
                                        {obtenerTotalRequeriemiento(dia)}
                                    </td>
                                ))}
                                <td className='bg-gradient'>
                                    {obtenerTotalFinal()}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )}

        {/* MODAL */}
        <Modal
            show={modalShow}
            onHide={() => setModalShow(false)}
            backdrop="static"
            keyboard={false}
            size={tipoModal == 'V' ? "lg" : "xl"}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName='bg-dark bg-gradient'
            centered
        >
            <Modal.Header closeButton closeVariant='white'>
                {tipoModal == 'V' && <div className='text-light fw-bold text-center w-100'>Validar Requerimiento</div>}
                {tipoModal == 'E' && productosEdit != null && (
                    <div className='text-light fw-bold text-center w-100'>
                        Editar Producto {dateConver.formatoFechaCorto(productosEdit[0].FECHA)}
                    </div>
                )}
            </Modal.Header>
            <Modal.Body className="bg-dark text-light">
                {tipoModal == 'V' && (
                    <div className='container-fluid text-light py-3'>
                        <h5>Una vez validada la proyección, no será posible modificarla.</h5>
                    </div>
                )}
                
                {tipoModal == 'E' && productosEdit !== null && (
                    <div className="row">
                        {/* COLUMNA EDICIÓN */}
                        <div className="col-md-4 border-end border-secondary">
                            <h6 className="text-center mb-3 text-info">ESTÁNDAR</h6>
                            <p className="text-center text-info" style={{ fontSize: '11px', marginBottom: '20px' }}> (EDITABLE)</p>
                            {productosEdit?.map((item, index) => (
                                <div key={index} className="d-flex align-items-center mb-2">
                                    <span className="flex-grow-1" style={{ fontSize: '13px' }}>{item.ABREVIACION}</span>
                                    <input
                                        type="number"
                                        readOnly={!puedeEditar(item.FECHA)}
                                        className="form-control form-control-sm w-25 text-center bg-dark text-light border-secondary"
                                        value={item.CANTIDAD}
                                        onChange={(e) => {
                                            const nuevos = productosEdit.map(p =>
                                                p.ID_PRODUCTO === item.ID_PRODUCTO
                                                    ? { ...p, CANTIDAD: parseInt(e.target.value) || 0 }
                                                    : p
                                            );
                                            setProductosEdit(nuevos);
                                        }}
                                    />
                                </div>
                            ))}
                        </div>

                        {/* COLUMNA SEMANA ANTERIOR */}
                        <div className="col-md-4">
                            <h6 className="text-center text-info mb-3">SEMANA ANTERIOR</h6>
                            {/* --- AQUÍ PONES EL PÁRRAFO --- */}
                            <p className="text-center text-info" style={{ fontSize: '11px', marginBottom: '20px' }}>
                                {fechaPasadaDeHaceSieteDias && fechaPasadaDeHaceSieteDias.toLocaleDateString('es-ES', {
                                    weekday: 'long',
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                }).replace(/^\w/, (c) => c.toUpperCase())}
                            </p>
                            {proyeccionHistorica.length > 0 ? (
                                proyeccionHistorica.map((hist, idx) => (
                                    <div key={idx} className="d-flex justify-content-between mb-2 p-1 bg-secondary bg-opacity-10 rounded">
                                        <span style={{ fontSize: '12px' }}>{hist.ABREVIACION}</span>
                                        <span className="fw-bold text-info">{hist.CANTIDAD}</span>
                                    </div>
                                ))
                            ) : (
                                <p className="text-center text-muted mt-4">Sin datos históricos</p>
                            )}
                        </div>

                        {/* COLUMNA PROMEDIO 3 SEMANAS */}
                        <div className="col-md-4 border-start border-secondary">
                            <h6 className="text-center text-warning mb-3">
                                PROMEDIO 3 SEMANAS
                            </h6>

                            <p className="text-center text-warning" style={{ fontSize: '11px', marginBottom: '20px' }}>
                                Promedio Ventas 3 semanas anteriores al {promedio && promedio.toLocaleDateString('es-ES', {
                                    weekday: 'long',
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                }).replace(/^\w/, (c) => c.toUpperCase())}
                            </p>

                          {productosEdit?.map((item, idx) => {
                            // Lógica de búsqueda (Locate):
                            // 1. Coincidencia directa de ID
                            // 2. Excepción para Pipoca: si el item es 187, busca el valor agrupado -5
                            const datoPromedio = promedioTresSemanas.find(p => 
                                String(p.ID_PRODUCTO) === String(item.ID_PRODUCTO) || 
                                (Number(item.ID_PRODUCTO) === 187 && String(p.ID_PRODUCTO) === "-5")
                            );

                            // Extraemos el valor numérico de forma segura
                            const valorMostrar = datoPromedio && datoPromedio.CANTIDAD_PROMEDIO != null
                                ? Number(datoPromedio.CANTIDAD_PROMEDIO).toFixed(2)
                                : "0.00";

                            return (
                                <div
                                    key={idx}
                                    className="d-flex justify-content-between mb-2 p-1 bg-warning bg-opacity-10 rounded"
                                >
                                    <span style={{ fontSize: '12px' }}>
                                        {item.ABREVIACION}
                                    </span>
                                    <span className="fw-bold text-warning">
                                        {valorMostrar}
                                    </span>
                                </div>
                            );
                        })}
                        </div>

                        {/* BOTÓN COPIAR */}
                        {proyeccionHistorica.length > 0 && (
                            <div className="mt-3 pt-2 border-top border-secondary text-center">
                                <button
                                    type="button"
                                    className="btn btn-outline-info btn-sm w-40"
                                    disabled={!puedeGuardar}
                                    onClick={copiarValoresHistoricos}
                                >
                                    <i className="fa-solid fa-copy me-2"></i>
                                    Copiar a columna edición
                                </button>
                                    {!puedeGuardar && (
                                        <div className="text-warning mt-2" style={{ fontSize: '12px' }}>
                                            ⚠️ No se puede editar: ya se validó
                                        </div>
                                    )}
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                {tipoModal == 'E' && (
                    <div className="w-100 d-flex justify-content-center mt-2">
                        <button
                            className="btn btn-sm btn-success w-50"
                            onClick={editarProducto}
                            disabled={!puedeGuardar}
                        >
                            <i className="fa-solid fa-thumbs-up me-2"></i>
                            Guardar Modificaciones
                        </button>
                         {!puedeGuardar && (
                                        <div className="text-warning mt-2" style={{ fontSize: '12px' }}>
                                            ⚠️ No se puede editar: ya se validó
                                        </div>
                                    )}
                    </div>
                    
                    
                )}
                {tipoModal == 'V' && (
                    <>
                        <button className='btn btn-sm btn-secondary' onClick={() => setModalShow(false)}>
                            <i className="fa-solid fa-xmark"></i> Cancelar
                        </button>
                        <button className='btn btn-sm btn-success' onClick={() => validarRequerimiento()}>
                            <i className="fa-solid fa-thumbs-up"></i> Validar
                        </button>
                    </>
                )}
            </Modal.Footer>
        </Modal>
    </>
);
}

export default RequerimientoSemanal